import React from "react";
import { motion } from "framer-motion";

const DEFAULT_EVENTS = [
  { name: "Tomorrowland 2026", mom3ntum: "€400", market: "€1,200" },
  { name: "קולדפליי – סיבוב הופעות", mom3ntum: "€150", market: "€650" },
  { name: "ריאל מדריד נגד ברצלונה", mom3ntum: "€180", market: "€900" },
  { name: "טיילור סוויפט / אדל", mom3ntum: "$160", market: "$850" },
  { name: "פסטיבל קואצ'לה", mom3ntum: "$550", market: "$1,400" },
];

export default function PricingTable({ config }) {
  const events = config?.events ?? DEFAULT_EVENTS;
  return (
    <section className="py-20 px-4" style={{ background: "#252525" }} dir="rtl">
      <div className="max-w-3xl mx-auto">

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <p className="text-xs font-black uppercase tracking-widest mb-3" style={{ color: "#c8f135" }}>המספרים מדברים בעד עצמם</p>
          <h2 className="font-black mb-3 text-white" style={{ fontSize: "clamp(1.6rem, 4vw, 2.4rem)" }}>
            תראו כמה אתם מפסידים כשאתם קונים בחוץ
          </h2>
          <p className="text-sm" style={{ color: "rgba(255,255,255,0.65)" }}>
            * המחירים להמחשה בלבד, מבוססים על מחירי שוק מול מחירי עלות רשמיים
          </p>
        </motion.div>

        {/* Pricing comparison table */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="rounded-2xl mb-6 overflow-hidden"
          style={{ border: "1px solid #1f1f1f" }}
        >
          {/* Table header */}
          <div
            className="grid grid-cols-3 items-center h-[62px] px-4 md:px-8"
            style={{ background: "#161616", borderBottom: "1px solid #1f1f1f" }}
          >
            <div className="text-right">
              <p className="text-base" style={{ color: "#c4c4c4" }}>אירוע</p>
            </div>
            <div className="text-center">
              <p className="text-xs font-semibold uppercase tracking-wide" style={{ color: "#c8f135" }}>Mom3ntum</p>
              <p className="text-xs uppercase tracking-wide" style={{ color: "#c8f135" }}>מחיר עלות</p>
            </div>
            <div className="text-center">
              <p className="text-xs font-semibold uppercase tracking-wide" style={{ color: "#f55" }}>שוק חופשי</p>
              <p className="text-xs uppercase tracking-wide" style={{ color: "#f55" }}>ספסרים</p>
            </div>
          </div>

          {/* Table rows */}
          {events.map((event, i) => (
            <div
              key={i}
              className="grid grid-cols-3 items-center h-[75px] px-4 md:px-8"
              style={{
                background: i % 2 === 0 ? "#111" : "#0e0e0e",
                borderBottom: i < events.length - 1 ? "1px solid #1a1a1a" : "none",
              }}
            >
              <div className="text-right">
                <p className="text-base font-semibold text-white">{event.name}</p>
              </div>
              <div className="text-center">
                <p className="text-xl font-semibold" style={{ color: "#c8f135" }}>{event.mom3ntum}</p>
                <svg className="mx-auto mt-1" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <circle cx="7" cy="7" r="6" stroke="#c8f135" strokeWidth="1.5" />
                  <path d="M4 7l2 2 4-4" stroke="#c8f135" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div className="text-center">
                <p className="text-xl font-semibold" style={{ color: "#f55" }}>{event.market}</p>
                <svg className="mx-auto mt-1" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <circle cx="7" cy="7" r="6" stroke="#f55" strokeWidth="1.5" />
                  <path d="M5 5l4 4M9 5l-4 4" stroke="#f55" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
              </div>
            </div>
          ))}
        </motion.div>

        {/* Insight box */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="rounded-2xl px-6 py-5 flex items-center gap-5"
          style={{ background: "#0E0E0E", borderRadius: "16px" }}
        >
          {/* Lightbulb icon — left side */}
          <img
            src="https://media.base44.com/images/public/69b41710d6b60acb7a810a52/e196b151c_lightbulb.png"
            alt="lightbulb"
            className="w-[51px] h-[51px] flex-shrink-0"
          />

          {/* Text block */}
          <div className="flex flex-col gap-1 text-right" style={{ width: "75%" }}>
            <p className="font-bold text-base leading-6" style={{ color: "#FCD575" }}>
              {config?.insight_heading ?? "המשמעות פשוטה:"}
            </p>
            <p className="text-sm leading-[23px]" style={{ color: "#C4C4C4", fontWeight: 500 }}>
              {config?.insight_text ?? "כשאתם קונים דרך הקהילה - אתם משלמים מחיר עלות כשקונים בחוץ - משלמים מחירי שוק מנופחים של ספסרים. חברי קהילת Mom3ntum חוסכים בממוצע בין 55% ל- 80% (!!) על כרטיסים לאירועי השיא של השנה."}
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}